export enum LoadingOrderStatus {
  Draft=0,
  InProgress=1,
  Completed=2,
  Synced=3,
  Processing=4,
}


